import apiClient from "./apiClient";

interface Address {
    street: string;
    house: string;
}

export interface PickupPoint {
    id: number;
    name: string;
    address: Address;
    warehouse_id: number; // Связь со складом
    warehouse?: {
        id: number;
        name: string;
    };
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

interface PickupPointsResponse {
    pickup_points: PickupPoint[];
}

export const fetchPickupPoints = async (): Promise<PickupPoint[]> => {
    try {
        const response = await apiClient.get<PickupPointsResponse>(`/api/pickup-points`);
        return response.data.pickup_points;
    } catch (error) {
        console.error('Error fetching pickup points:', error);
        throw error;
    }
};